    <div class="table-container">

        <apc-datatable-filters (displaySearchEvent)="displaySearch()" (clearSearchEvent)="clearSearch()"
            (exportCSVEvent)="exportCSV()" (refreshDataEvent)="refreshData()"
            (selectTableColumnsEvent)="addNewColumn($event);" (selectAllColumnsEvent)="selectAllColumns()"
            (unselectAllColumnsEvent)="unselectAllColumns()" [columnsToDisplayInDropdown]="columnsToDisplayInDropdown"
            [showSearch]="showSearch" [enableFilter]="enableFilter" [selectedTableColumns]="selectedTableColumns"
            [selectedRows]="selectedRows" [section]="section">
        </apc-datatable-filters>

        <ngx-datatable #table class="apc" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="50"
            rowHeight="auto" [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size"
            (page)="setPage($event)" sortType="single" (sort)="onSort($event)" [externalSorting]="true"
            [columns]="selectedTableColumns" [externalPaging]="true" [sorts]="sortArray">

            <ng-template #checkboxCell let-row="row" let-value="value" let-column="column" let-i="index">
                <input type="checkbox" (change)="onRowSelect($event, row)" [ngModel]="row.checked" />
            </ng-template>

            <ng-template #personNameCell let-row="row" let-value="value" let-column="column" let-i="index">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''"> {{value}} </div>
            </ng-template>

            <ng-template #dateCell let-row="row" let-value="value" let-column="column">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''"> {{value}} </div>
            </ng-template>

            <ng-template #percentageCell let-row="row" let-value="value" let-column="column">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''">{{value | percent: '1.0-2':'it' }} </div>
            </ng-template>

            <ng-template #timeCell let-row="row" let-value="value" let-column="column">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''">{{ (value !== '') ?
                    (convertStringToDate(value) | date:'HH:mm') : "" }} </div>
            </ng-template>

            <ng-template #plainCell let-row="row" let-value="value" let-column="column">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''"> {{value}} </div>
            </ng-template>

            <ng-template #dayHourFormat let-row="row" let-value="value" let-column="column">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''"> {{value}}h ({{(value/8).toFixed(2)}}d) </div>
            </ng-template>
            

            <ng-template #currencyCell let-row="row" let-value="value" let-column="column">
                <div isEllipsisActive [id]="column.name" class="column-value"
                    [ngClass]="showSearch ? 'text-decoration-underline' : ''"> {{value | number:'1.2-2': 'it'}} € </div>
            </ng-template>

            <ng-template #translateCell let-column="column">
                <div [ngClass]="showSearch ? 'search-wrapper-input' : ''" *ngIf="column.name !== 'identifier'">
                    <div isEllipsisActive class="header-cell" [ngClass]="showSearch ? 'search-open' : ''">{{'columnName.' +
                        column.name |
                        translate}}</div>
                    <div *ngIf="showSearch" class="search-wrapper">
                        <input *ngIf="inputType(column.name) !== 'boolean'" [type]="inputType(column.name)"
                            [ngModel]="column.searchValue" class="form-control search-input"
                            [ngClass]="column.searchValue && column.searchValue.length > 0 ? 'has-value' : 'search-input-filter'"
                            [id]="column.name" (click)="$event.stopPropagation()"
                            max="2999-12-31"
                            (ngModelChange)="this.searchColumnUpdate.next({ value: $event, id: column.name })" />


                        <div *ngIf="inputType(column.name) === 'boolean'" class="boolean-filter">
                            <div class="btn-group btn-group-toggle">
                                <label class="btn-secondary boolButton"
                                    [ngClass]="column.searchValue === 'true' ? 'active' : ''" ngbButtonLabel
                                    (click)="this.search('true', column.name)">
                                    <input type="checkbox" ngbButton>True
                                </label>
                                <label class="btn-secondary boolButton"
                                    [ngClass]="column.searchValue === 'false' ? 'active' : ''" ngbButtonLabel
                                    (click)="this.search('false', column.name)">
                                    <input type="checkbox" ngbButton> False
                                </label>
                            </div>
                        </div>
                        <div *ngIf="column.searchValue && column.searchValue.length > 0" class="clear-icon"
                            aria-label="clear" [inlineSVG]="'assets/ico/clear-button-red.svg'"
                            (click)="clearSearchValue(column.name)"></div>
                    </div>
                </div>
                <div *ngIf="column.name === 'identifier'">
                    <input type="checkbox" (click)="selectAllRows($event)" [ngModel]="column.checked" />
                </div>
            </ng-template>


            <ng-template #navigationIcon let-row="row" let-value="value">
                <a ngbTooltip="{{'buttons.detailsPage' | translate}}" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover" [routerLink]="getDetailsRouteLink(row)" class="greenEye">
                    <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
                </a>
            </ng-template>

            <ng-template #navigationAndJiraIcon let-row="row" let-value="value">
                <a ngbTooltip="{{'buttons.projectDetails' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" [routerLink]="getDetailsRouteLink(row)" class="greenEye">
                    <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
                </a>
                <a ngbTooltip="{{'buttons.jiraProject' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" [href]="row.jiraUrl" target="_blank" class="jiraLink ml-2">
                    <img class="icon" style="padding: 3px 3px 5px 4px;" src="assets/ico/jira-icon.svg" alt="jira icon"/>
                </a>
                
            </ng-template>

            <ng-template #jiraIcon let-row="row" let-value="value">
                <a ngbTooltip="{{'buttons.jiraProject' | translate}}" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover" [href]="row.jiraUrl" target="_blank" class="jiraLink ml-2">
                    <div aria-label="details" [inlineSVG]="'assets/ico/jira-icon.svg'"></div>
                </a>
            </ng-template>

            <ng-template #errorDetails let-row="row" let-value="value">
                <div class="error-wrapper">
                <nejo-error-detail [json]="row.payload" [updated]="row.updatedAt"></nejo-error-detail>
                <div ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip"  triggers="hover"  class="delete-button-wrapper">
                    <app-modal-info title="Confirm action" [text]="'Are you sure to delete this Error?'" color="red"
                        [isQuestion]="true" iconSrc="assets/ico/trash-alt-regular.svg" (confirmEvent)="deleteError(row)">
                        <span action>
                            <div *checkPermission="{ role: 'editor'}" class="deleteIcon">
                                <div aria-label="delete" [inlineSVG]="'assets/ico/trash-alt-regular.svg'"></div>
                            </div>
                        </span>
                    </app-modal-info>
                </div>
            </div>
            </ng-template>


        </ngx-datatable>

    </div>